var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.442 9.69V1.984a.984.984 0 111.968 0V9.79l1.836-1.837a.984.984 0 111.391 1.392L7.31 12.673a.98.98 0 01-.606.284.984.984 0 01-1.012-.236L2.363 9.392a.984.984 0 111.39-1.39l1.69 1.688z"
  })));
}
export default SvgSortDown;